import { HttpService } from "./http.service";

const basePath = "/EquipmentConfig";
const request = HttpService.handleRequest();

export const EquipmentConfigService = {
  getByEquipment
};

async function getByEquipment(id) {
  return request.get(`${basePath}/GetByEquipmentId/${id}`);
}

export default EquipmentConfigService;